<template>
  <div id="app">
    <div class="home-wrapper" :class="{ 'slide-up': profileVisible }">
      <div class="main">
        <div class="container Theme_colors Frosted_glass">
          <Home @show-profile="onShowProfile" />
        </div>
      </div>
    </div>

    <ProfilePage
      :class="{ 'slide-in': profileContentVisible }"
      @close-profile="onCloseProfile"
    />

    <PageFooter class="app-footer" />
  </div>
</template>

<script>
import { inject } from "@vercel/analytics"
import Home from './components/Home.vue';
import PageFooter from './components/Footer.vue';
import ProfilePage from './components/ProfilePage.vue';

export default {
  name: 'App',
  components: {
    Home,
    PageFooter,
    ProfilePage
  },
  data() {
    return {
      profileVisible: false,
      profileContentVisible: false
    }
  },
  methods: {
    onShowProfile() {
      this.profileVisible = true
      setTimeout(() => {
        this.profileContentVisible = true
      }, 600)
    },
    onCloseProfile() {
      this.profileContentVisible = false
      setTimeout(() => {
        this.profileVisible = false
      }, 600)
    }
  },
  mounted() {
    inject();
  }
}
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
}

.home-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}

.home-wrapper.slide-up {
  transform: translateY(-100%);
}

.app-footer {
  z-index: 11;
}

.main {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.container {
  width: 80%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

@media (max-width: 768px) {
  .container {
    width: 100%;
    padding: 10px;
    padding-bottom: 65px;
  }
}
</style>